import React from 'react';
import Icon from '../../../components/AppIcon';

const CertificationBadge = () => {
  const certifications = [
    {
      icon: 'ShieldCheck',
      title: '100% Halal Certified',
      description: 'All ingredients are halal certified and verified'
    },
    {
      icon: 'Award',
      title: 'FSSAI Approved',
      description: 'Licensed food safety and hygiene standards'
    },
    {
      icon: 'Leaf',
      title: 'Fresh Ingredients',
      description: 'Daily fresh preparation with quality ingredients'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-[var(--color-primary)]/10 to-[var(--color-accent)]/10 rounded-xl p-6 border border-[var(--color-border)]">
      <h3 className="text-lg font-semibold text-[var(--color-foreground)] mb-4 flex items-center gap-2">
        <Icon name="BadgeCheck" size={24} color="var(--color-primary)" />
        Our Certifications
      </h3>
      <div className="space-y-4">
        {certifications?.map((cert, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-[var(--color-primary)] flex items-center justify-center flex-shrink-0">
              <Icon name={cert?.icon} size={20} color="#FFFFFF" />
            </div>
            <div>
              <h4 className="text-sm font-semibold text-[var(--color-foreground)] mb-1">
                {cert?.title}
              </h4>
              <p className="text-xs text-[var(--color-muted-foreground)]">
                {cert?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CertificationBadge;